import { ApiClientConfig } from '../../types/ApiClientConfig';

export const DlsUrlsPerStage: ApiClientConfig = {
  LOCAL: {
    basePath: 'https://eu.api.oneweb.mercedes-benz.com/commerce/dls/v2',
    apiKey: '71b7c41e-3e7e-4711-9fb2-9e487ac14b39',
  },
  TEST: {
    basePath: 'https://dev.eu.api.oneweb.mercedes-benz.com/commerce/dls/dev-01/v2',
    apiKey: 'c5ee7d0e-c68e-475e-bf57-a4b9658dfa40',
  },
  INT: {
    basePath: 'https://test.eu.api.oneweb.mercedes-benz.com/commerce/dls/int-01/v2',
    apiKey: 'f17778fc-a189-4eca-bb6f-eb65f0913fee',
  },
  PPROD: {
    basePath: 'https://int.api.oneweb.mercedes-benz.com/commerce/dls/v2',
    apiKey: 'f17778fc-a189-4eca-bb6f-eb65f0913fee',
  },
  PROD: {
    basePath: 'https://eu.api.oneweb.mercedes-benz.com/commerce/dls/v2',
    apiKey: '71b7c41e-3e7e-4711-9fb2-9e487ac14b39',
  },
};

export const DlsOverseasUrlsPerStage: {
  PROD: {
    basePath: string;
    apiKey?: string;
  };
} = {
  PROD: {
    basePath: 'https://ap.api.oneweb.mercedes-benz.com/commerce/dls/v2',
    apiKey: '2e6bf31f-1088-4497-84a5-3a0b8d429cc7',
  },
};
